export const MODAL_CONTENT_SIZING = { maxWidth: "60vw", maxHeight: "95vh" };
export const MODAL_SIZING = { base: "full", sm: "lg", md: "xl", lg: "2xl", xl: "3xl" };
export const TOAST_DURATION = 3000;
